import { useSelector } from 'react-redux'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import { Subscription, State, TierOffer } from 'types'

export const useCreditCount = (): number => {
  const profile = useProfile()
  const subscriptionId = profile?.subscription
  return useSelector<State, number>(state => state.entities.subscriptions[String(subscriptionId)]?.credit_count)
}

export const useSubscription = (): Subscription => {
  const profile = useProfile()
  const subscriptionId = profile?.subscription
  return useSelector<State, Subscription>(state => state.entities.subscriptions[String(subscriptionId)])
}

export const useIsDirectPayment = (selectedOffer: TierOffer | undefined, selectedMonths: number | undefined | null): boolean => {
  const subscription = useSubscription()
  const hasFreeTier = subscription?.state === 'FREE'
  const isOnTrial = subscription?.state === 'TRIAL'
  const subscriptionTerminated = subscription?.state === 'TERMINATED'
  const currentlyOnMonthly = subscription?.renewal_period?.months === 1
  const isUpgrade =
    (selectedOffer?.tier.credits_give_per_month || 0) > (subscription?.renewal_period?.tier.credits_give_per_month || 0) ||
    (selectedMonths || 0) > subscription?.renewal_period?.months
  const isChangingToSameAsNextPeriod =
    selectedOffer?.tier.id === subscription?.next_renewal_period?.tier?.id && selectedMonths === subscription?.next_renewal_period?.months
  const isChangingToSameAsCurrent =
    selectedOffer?.tier.id === subscription?.tier?.id && selectedMonths === subscription?.renewal_period?.months
  return (
    isOnTrial ||
    subscriptionTerminated ||
    (!hasFreeTier && currentlyOnMonthly && isUpgrade && !isChangingToSameAsNextPeriod && !isChangingToSameAsCurrent)
  )
}
